import { useEffect, useRef, useState, type CSSProperties } from 'react'

/** Скорость бегущей строки, пикселей в секунду. */
const SPEED = 40

/**
 * Название курса в «Недавних»: не помещается — при наведении на строку бежит
 * до конца и обратно (паузы на краях), иначе просто обрезано многоточием.
 * Расстояние меряется В МОМЕНТ наведения: тогда строка уже уже на ширину кнопок.
 */
export const MarqueeTitle = ({ title }: { title: string }) => {
  const boxRef = useRef<HTMLSpanElement>(null)
  const textRef = useRef<HTMLSpanElement>(null)
  const [distance, setDistance] = useState(0)

  // Наведение — на ВСЮ строку меню (вместе с кнопками справа), а не только на текст.
  useEffect(() => {
    const row = boxRef.current?.closest('li')
    if (!row) return
    const enter = () =>
      requestAnimationFrame(() => {
        const box = boxRef.current
        const text = textRef.current
        if (box && text) setDistance(Math.max(0, text.scrollWidth - box.clientWidth))
      })
    const leave = () => setDistance(0)
    row.addEventListener('mouseenter', enter)
    row.addEventListener('mouseleave', leave)
    return () => {
      row.removeEventListener('mouseenter', enter)
      row.removeEventListener('mouseleave', leave)
    }
  }, [])

  const running = distance > 0
  return (
    <span ref={boxRef} className="block min-w-0 overflow-hidden">
      <span
        ref={textRef}
        className={
          running
            ? 'inline-block whitespace-nowrap animate-[recent-marquee_var(--marquee-dur)_ease-in-out_infinite_alternate]'
            : 'block truncate'
        }
        style={
          running
            ? ({
                '--marquee-distance': `${distance}px`,
                // Паузы на краях заложены в ключевые кадры (по 15% с каждой стороны).
                '--marquee-dur': `${Math.max(2, distance / SPEED / 0.7)}s`,
              } as CSSProperties)
            : undefined
        }
      >
        {title}
      </span>
    </span>
  )
}
